<!-- MAISON ET ARBRES -->
<div
  class="tree-anim"
  inViewport
  [inViewportOptions]="{ threshold: [0] }"
  (inViewportAction)="startTreeAnimation($event)"
>
  <div class="house-illustration">
    <app-property-scene-desktop
      *ngIf="!hasSmallImage"
      class="desktop-only"
      [isIndicateurRisqueMoyenHaut]="isIndicateurRisqueMoyenHaut"
    ></app-property-scene-desktop>
    <app-property-scene-mobile
      class="property-scene-mobile"
      [ngClass]="{ 'small-image': hasSmallImage }"
      [isIndicateurRisqueMoyenHaut]="isIndicateurRisqueMoyenHaut"
    ></app-property-scene-mobile>
  </div>
</div>

<!-- NUAGES ANIMES MOBILE -->
<div
  class="nuages-small"
  [ngClass]="{ 'small-image': hasSmallImage }"
  inViewport
  [inViewportOptions]="{ threshold: [0] }"
  (inViewportAction)="startSmallCloudsAnimation($event)"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="426" height="58" viewBox="0 0 426 58">
    <g fill="none" fill-rule="evenodd">
      <g fill="#D7E6FA" fill-rule="nonzero" stroke="#146FD2" stroke-width="1.5">
        <g>
          <g>
            <path
              class="right-cloud"
              vector-effect="non-scaling-stroke"
              d="M67.7 28.1H25.6c-.5 0-1-.4-1-1 0-2 .8-4 2.2-5.5 1.3-1.3 2.9-2.1 4.7-2.3 2.2-5.8 7.7-9.6 13.9-9.6 5 0 9.6 2.5 12.3 6.6 2.9 0 5.6 1.1 7.7 3.1 2.1 2 3.3 4.7 3.3 7.6 0 .3-.1.5-.3.7-.2.2-.4.4-.7.4z"
              transform="translate(-144 -1156) translate(145 1156) translate(355 29)"
            />
            <path
              class="right-cloud"
              vector-effect="non-scaling-stroke"
              d="M43.1 19.3H1c-.5 0-1-.4-1-1 0-2 .8-4 2.2-5.5 1.3-1.3 2.9-2.1 4.7-2.3C9.1 4.7 14.6.9 20.8.9c5 0 9.6 2.5 12.3 6.6 2.9 0 5.6 1.1 7.7 3.1 2.1 2 3.3 4.7 3.3 7.6 0 .3-.1.5-.3.7-.2.3-.4.4-.7.4z"
              transform="translate(-144 -1156) translate(145 1156) translate(355 29)"
            />
          </g>
          <path
            class="left-cloud"
            vector-effect="non-scaling-stroke"
            d="M60.64 18.8H1.04c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.2-.8.6-3.6 3.6-6.3 7.1-6.7 2.3-6.1 8-10.1 14.6-10.1 3.4 0 6.7 1.1 9.4 3.2 1.9-1.1 4-1.6 6.1-1.6 3.6 0 7 1.5 9.3 4.3.9-.2 1.8-.3 2.8-.3 6.4 0 11.8 5 12.3 11.4 0 .3-.1.5-.3.7-.2 0-.4.2-.7.2z"
            transform="translate(-144 -1156) translate(145 1156)"
          />
        </g>
      </g>
    </g>
  </svg>
</div>

<!-- NUAGES ANIMES DESKTOP -->
<div
  class="nuages-large"
  *ngIf="!hasSmallImage"
  inViewport
  [inViewportOptions]="{ threshold: [0] }"
  (inViewportAction)="startLargeCloudsAnimation($event)"
>
  <svg
    width="1202px"
    height="65px"
    viewBox="0 0 1202 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Group 6</title>
    <g id="2-Mon-paiement,-mes-frais" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Desktop-animation-nuages" transform="translate(-194.000000, -1635.000000)">
        <g id="landscape-01-copy" transform="translate(194.000000, 1635.000000)">
          <g id="Group-6" transform="translate(0.960770, 0.900000)">
            <g
              id="Group"
              transform="translate(365.039230, 11.100000)"
              fill="#D7E6FA"
              fill-rule="nonzero"
              stroke="#146FD2"
              stroke-width="1.5"
            >
              <path
                class="left-cloud"
                vector-effect="non-scaling-stroke"
                d="M68.2,28 L26.1,28 C25.6,28 25.1,27.6 25.1,27 C25.1,25 25.9,23 27.3,21.5 C28.6,20.2 30.2,19.4 32,19.2 C34.2,13.4 39.7,9.6 45.9,9.6 C50.9,9.6 55.5,12.1 58.2,16.2 C61.1,16.2 63.8,17.3 65.9,19.3 C68,21.3 69.2,24 69.2,26.9 C69.2,27.2 69.1,27.4 68.9,27.6 C68.8,27.9 68.5,28 68.2,28 Z"
                id="nuage2_3_"
              ></path>
              <path
                class="left-cloud"
                vector-effect="non-scaling-stroke"
                d="M43.6,19.3 L1.5,19.3 C1,19.3 0.5,18.9 0.5,18.3 C0.5,16.3 1.3,14.3 2.7,12.8 C4,11.5 5.6,10.7 7.4,10.5 C9.6,4.7 15.1,0.9 21.3,0.9 C26.3,0.9 30.9,3.4 33.6,7.5 C36.5,7.5 39.2,8.6 41.3,10.6 C43.4,12.6 44.6,15.3 44.6,18.2 C44.6,18.5 44.5,18.7 44.3,18.9 C44.1,19.2 43.9,19.3 43.6,19.3 Z"
                id="nuage2_2_"
              ></path>
            </g>
            <path
              class="left-cloud"
              vector-effect="non-scaling-stroke"
              d="M266.63923,43.3 L207.03923,43.3 C206.73923,43.3 206.43923,43.2 206.23923,43 C206.03923,42.8 205.93923,42.5 206.03923,42.2 C206.63923,38.6 209.63923,35.9 213.13923,35.5 C215.43923,29.4 221.13923,25.4 227.73923,25.4 C231.13923,25.4 234.43923,26.5 237.13923,28.6 C239.03923,27.5 241.13923,27 243.23923,27 C246.83923,27 250.23923,28.5 252.53923,31.3 C253.43923,31.1 254.33923,31 255.33923,31 C261.73923,31 267.13923,36 267.63923,42.4 C267.63923,42.7 267.53923,42.9 267.33923,43.1 C267.23923,43.1 266.93923,43.3 266.63923,43.3 Z"
              id="nuaage1"
              stroke="#146FD2"
              stroke-width="1.5"
              fill="#D7E6FA"
              fill-rule="nonzero"
            ></path>
            <path
              class="left-cloud"
              vector-effect="non-scaling-stroke"
              d="M514.13923,20.9 L454.53923,20.9 C454.23923,20.9 453.93923,20.8 453.73923,20.6 C453.53923,20.4 453.43923,20.1 453.53923,19.8 C454.13923,16.2 457.13923,13.5 460.63923,13.1 C462.93923,7 468.63923,3 475.23923,3 C478.63923,3 481.93923,4.1 484.63923,6.2 C486.53923,5.1 488.63923,4.6 490.73923,4.6 C494.33923,4.6 497.73923,6.1 500.03923,8.9 C500.93923,8.7 501.83923,8.6 502.83923,8.6 C509.23923,8.6 514.63923,13.6 515.13923,20 C515.13923,20.3 515.03923,20.5 514.83923,20.7 C514.63923,20.7 514.43923,20.9 514.13923,20.9 Z"
              id="nuaage1_1_"
              stroke="#146FD2"
              stroke-width="1.5"
              fill="#D7E6FA"
              fill-rule="nonzero"
            ></path>
            <path
              class="right-cloud"
              vector-effect="non-scaling-stroke"
              d="M1021.13923,34.1 L979.03923,34.1 C978.53923,34.1 978.03923,33.7 978.03923,33.1 C978.03923,31.1 978.83923,29.1 980.23923,27.6 C981.53923,26.3 983.13923,25.5 984.93923,25.3 C987.13923,19.5 992.63923,15.7 998.83923,15.7 C1003.83923,15.7 1008.43923,18.2 1011.13923,22.3 C1014.03923,22.3 1016.73923,23.4 1018.83923,25.4 C1020.93923,27.4 1022.13923,30.1 1022.13923,33 C1022.13923,33.3 1022.03923,33.5 1021.83923,33.7 C1021.73923,34 1021.43923,34.1 1021.13923,34.1 Z"
              id="nuage2_4_"
              stroke="#146FD2"
              stroke-width="1.5"
              fill="#D7E6FA"
              fill-rule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              vector-effect="non-scaling-stroke"
              x="0.0392304845"
              y="0.1"
              width="1200"
              height="63"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
</div>
